import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import ProtectedRoute from './auth/ProtectedRoute';
import Login from './pages/Login';
import AppErrorBoundary from './components/AppErrorBoundary';
import UserManagement from './pages/UserManagement';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import Finances from './pages/Finances';
import Tasks from './pages/Tasks';
import Management from './pages/Management';
import Roadmap from './pages/Roadmap';
import Customers from './pages/Customers'
import SystemsMap from './pages/SystemsMap'
import Quotes from './pages/Quotes'
import Pricing from './pages/Pricing'
import JobPlanner from './pages/JobPlanner'
import JobActions from './pages/JobActions'
import SoftwareLicenses from './pages/SoftwareLicenses'
import SoftwareInstallers from './pages/SoftwareInstallers'
import Notes from './pages/Notes'
const App = () => {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Router>
        <AppErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/finances" element={<Finances />} />
                <Route path="/tasks" element={<Tasks />} />
                <Route path="/management" element={<Management />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/notes" element={<Notes />} />
                <Route path="/quotes" element={<Quotes />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/planner" element={<JobPlanner />} />
                <Route path="/job-actions" element={<JobActions />} />
                <Route path="/website-planner" element={<Navigate to="/planner" replace />} />
                <Route path="/roadmap" element={<Roadmap />} />
                <Route path="/systemsmap" element={<SystemsMap />} />
                <Route path="/users" element={<UserManagement />} />
                <Route path="/software-licenses" element={<SoftwareLicenses />} />
                <Route path="/software-installers" element={<SoftwareInstallers />} />
              </Route>
            </Route>
          </Routes>
        </AppErrorBoundary>
      </Router>
    </Box>
  );
};

export default App;
